import NativeActivityIndicator from './NativeActivityIndicator';

export default NativeActivityIndicator;
